/** Backend checkers keys for "catalog" module */
export enum CatalogCheckersEnum {
  /** Check that accounting account(s) exists by identifier(s) */
  ACCOUNTING_ACCOUNT_ASSERT_EXISTS_BY_ID = 'catalog/accounting-account-assert-exists-by-id',
  /** Check that accounting account(s) exists by DTO(s) */
  ACCOUNTING_ACCOUNT_ASSERT_EXISTS_BY_DTO = 'catalog/accounting-account-assert-exists-by-dto',
  /** Check that approval scheme(s) exists by identifier(s) */
  APPROVAL_SCHEME_ASSERT_EXISTS_BY_ID = 'catalog/approval-scheme-assert-exists-by-id',
  /** Check that approval scheme(s) exists by DTO(s) */
  APPROVAL_SCHEME_ASSERT_EXISTS_BY_DTO = 'catalog/approval-scheme-assert-exists-by-dto',
  /** Check whether budget classification code value is unique */
  BUDGET_CLASSIFICATION_CODE_UNIQUE = 'catalog/budget-classification-code-unique',
  /** Check that budget classification code(s) exists by identifier(s) */
  BUDGET_CLASSIFICATION_CODE_ASSERT_EXISTS_BY_ID = 'catalog/budget-classification-code-assert-exists-by-id',
  /** Check that budget classification code(s) exists by DTO(s) */
  BUDGET_CLASSIFICATION_CODE_ASSERT_EXISTS_BY_DTO = 'catalog/budget-classification-code-assert-exists-by-dto',
  /** Check whether budget revenue admin code is unique */
  BUDGET_REVENUE_ADMIN_CODE_UNIQUE = 'catalog/budget-revenue-admin-code-unique',
  /** Check that budget revenue admin(s) exists by identifier(s) */
  BUDGET_REVENUE_ADMIN_ASSERT_EXISTS_BY_ID = 'catalog/budget-revenue-admin-assert-exists-by-id',
  /** Check that budget revenue admin(s) exists by DTO(s) */
  BUDGET_REVENUE_ADMIN_ASSERT_EXISTS_BY_DTO = 'catalog/budget-revenue-admin-assert-exists-by-dto',
  /** Check that room(s) exists by identifier(s) */
  ROOM_ASSERT_EXISTS_BY_ID = 'catalog/room-assert-exists-by-id',
  /** Check that room(s) exists by DTO(s) */
  ROOM_ASSERT_EXISTS_BY_DTO = 'catalog/room-assert-exists-by-dto',
  /** Check that direction(s) exists by identifier(s) */
  DIRECTION_ASSERT_EXISTS_BY_ID = 'catalog/direction-assert-exists-by-id',
  /** Check that direction(s) exists by DTO(s) */
  DIRECTION_ASSERT_EXISTS_BY_DTO = 'catalog/direction-assert-exists-by-dto',
  /** Check that currency(ies) exists by identifier(s) */
  CURRENCY_ASSERT_EXISTS_BY_ID = 'catalog/currency-assert-exists-by-id',
  /** Check that currency(ies) exists by identifier(s) */
  CURRENCY_ASSERT_EXISTS_BY_DTO = 'catalog/currency-assert-exists-by-dto',
  /** Check whether currency with same ISO-4217 numeric code already exists */
  CURRENCY_ISO_NUMERIC_UNIQUE = 'catalog/currency-iso-numeric-unique',
  /** Check whether currency with same ISO-4217 character code already exists */
  CURRENCY_ISO_CHARACTER_UNIQUE = 'catalog/currency-iso-character-unique',
  /** Check that parent direction is valid (not direction itself and not descendant) */
  CHECK_PARENT_DIRECTION_BY_ID = 'catalog/check-parent-direction-by-id',
  /** Check that parent direction is valid (not direction itself and not descendant) */
  CHECK_PARENT_DIRECTION_BY_DTO = 'catalog/check-parent-direction-by-dto',
  /** Check that general direction does not refer recursively to this direction */
  CHECK_GENERAL_DIRECTION_CIRCULAR_DEPENDENCY_BY_ID = 'catalog/check-general-direction-circular-dependency-by-id',
  /** Check that general direction does not refer recursively to this direction */
  CHECK_GENERAL_DIRECTION_CIRCULAR_DEPENDENCY_BY_DTO = 'catalog/check-general-direction-circular-dependency-by-dto',
  /** Check that unit(s) exists by identifier(s) */
  UNIT_ASSERT_EXISTS_BY_ID = 'catalog/unit-assert-exists-by-id',
  /** Check that unit(s) exists by DTO(s) */
  UNIT_ASSERT_EXISTS_BY_DTO = 'catalog/unit-assert-exists-by-dto',
  /** Check that filial(s) exists by identifier(s) */
  FILIAL_ASSERT_EXISTS_BY_ID = 'catalog/filial-assert-exists-by-id',
  /** Check that filial(s) exists by DTO(s) */
  FILIAL_ASSERT_EXISTS_BY_DTO = 'catalog/filial-assert-exists-by-dto',
  /** Check that master milestone(s) exists by identifier(s) */
  MASTER_MILESTONE_ASSERT_EXISTS_BY_ID = 'catalog/master-milestone-assert-exists-by-id',
  /** Check that master milestone(s) exists by DTO(s) */
  MASTER_MILESTONE_ASSERT_EXISTS_BY_DTO = 'catalog/master-milestone-assert-exists-by-dto',
  /** Check that nomenclature group(s) exists by identifier(s) */
  NOMENCLATURE_GROUP_ASSERT_EXISTS_BY_ID = 'catalog/nomenclature-group-assert-exists-by-id',
  /** Check that nomenclature group(s) exists by DTO(s) */
  NOMENCLATURE_GROUP_ASSERT_EXISTS_BY_DTO = 'catalog/nomenclature-group-assert-exists-by-dtos',
  /** Check that nomenclature item(s) exists by identifier(s) */
  NOMENCLATURE_ITEM_ASSERT_EXISTS_BY_ID = 'catalog/nomenclature-item-assert-exists-by-id',
  /** Check that nomenclature item(s) exists by DTO(s) */
  NOMENCLATURE_ITEM_ASSERT_EXISTS_BY_DTO = 'catalog/nomenclature-item-assert-exists-by-dtos',
  /** Check that cost center(s) exists by identifier(s) */
  COST_CENTER_ASSERT_EXISTS_BY_ID = 'catalog/cost-center-assert-exists-by-id',
  /** Check that cost center(s) exists by DTO(s) */
  COST_CENTER_ASSERT_EXISTS_BY_DTO = 'catalog/cost-center-assert-exists-by-dto',
  /** Check that payer status(es) exists by identifier(s) */
  PAYER_STATUS_ASSERT_EXISTS_BY_ID = 'catalog/payer-status-assert-exists-by-id',
  /** Check that payer status(es) exists by identifier(s) */
  PAYER_STATUS_ASSERT_EXISTS_BY_DTO = 'catalog/payer-status-assert-exists-by-dto',
  /** Check whether payer status code is unique */
  PAYER_STATUS_CODE_UNIQUE = 'catalog/payer-status-code-unique',
}
